type Option<T> = T & {
  label: string;
};

export function sortSelectOptions<T>(options: Option<T>[]) {
  return options.sort((optionA, optionB) => optionA.label.localeCompare(optionB.label));
}
